<template>
  <div class="stake-list-box" v-if="alertShow">
    <div class="stake-list">
      <p class="stake-list-close"><img src="../../../static/images/svg/close.svg" alt="" @click="close"></p>
      <div class="stake-list-msg">
        <h3>Available coins</h3>
        <div class="stake-list-scroll">
          <ul>
            <li v-for="(item, index) in stakingList" :key="index" @click="changeStaking(item.url)">
              <div class="stake-list-msg-img-type">
                <img :src="'../../../static/images/svg/'+item.img_name +'.svg'" class="stake-list-msg-type" alt="">
                <p>{{item.staking_name}}</p>
                <span>{{item.coin_type}}</span>
              </div>
              <img src="../../../static/images/svg/open.svg" alt="">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue from '../../main.js'
export default {
  data () {
    return {
      alertShow: true
    }
  },
  computed: {
    stakingList () {
      return vue.$store.getters.coinMsg
    }
  },
  methods: {
    changeStaking: function (url) {
      this.alertShow = false
      if (url === vue.$route.path) return
      vue.$router.push(url)
    },
    close: function () {
      this.alertShow = false
    }
  }
}
</script>
<style scoped>
.stake-list-box{
  display: flex;
  position: fixed !important;
  padding: 14px 14px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 30000;
  background: rgba(0, 0, 0, 0.4);
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
}
.stake-list{
  max-width: 370px;
  width: 100%;
  min-height: 292px;
  background: #F5F7F7;
  border-radius: 40px;
}
.stake-list-box .stake-list .stake-list-close{
  margin: 24px 24px 0 0;
  text-align: right;
}
.stake-list-box .stake-list .stake-list-close img{
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.stake-list-box .stake-list .stake-list-msg{
  padding-bottom: 50px;
}
.stake-list-box .stake-list .stake-list-msg h3{
  font-size: 20px;
  font-family: 'PingFangSC-Heavy';
  font-weight: 800;
  color: #303030;
  padding: 0 50px;
}
.stake-list-box .stake-list .stake-list-scroll{
  overflow-y: auto;
  padding: 0 50px;
  height: 500px;
}
.stake-list-box .stake-list .stake-list-msg ul li{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 23px 20px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px #CDCDCD;
  margin-top: 14px;
  cursor: pointer;
}
.stake-list-box .stake-list .stake-list-msg ul li .stake-list-msg-img-type{
  display: flex;
  align-items: center;
}
.stake-list-box .stake-list .stake-list-msg ul li img{
  width: 19px;
  height: 9px;
}
.stake-list-box .stake-list .stake-list-msg ul li p{
  font-size: 16px;
  font-family: 'PingFangSC-Regular';
  font-weight: 400;
  color: #303030;
}
.stake-list-box .stake-list .stake-list-msg ul li .stake-list-msg-img-type p{
  margin: 0 10px;
  font-size: 16px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
}
.stake-list-box .stake-list .stake-list-msg ul li .stake-list-msg-img-type span{
  font-size: 14px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #D8D8D8;
}
.stake-list-box .stake-list .stake-list-msg .stake-list-msg-type{
  width: 22px;
  height: auto;
}
@media (max-width: 862px) {
  .stake-list{
    border-radius: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/changeStaking/index.vue